import { config } from "config";

export const environment = {
  defaultRedirectAppUrl: config.defaultRedirectAppUrl,
  firebaseConfig: config.firebaseConfig,
  defaultDomain: config.defaultDomain,
  apiUrl: config.apiUrl
};
